import classNames from 'classnames/bind';
import React from 'react';

import styles from './index.module.scss';
import Save from './Save';
import Specs from './Specs';

const cx = classNames.bind(styles);

const Header = () => {
  return (
    <div className={cx('container')}>
      <Save />
      <Specs />
    </div>
  );
};

export default Header;
